export const DEFAULT_SLIDE_TIMEOUT = 100;
export const DEFAULT_DRAG_THRESHOLD = 15;
export const DEFAULT_DRAG_SNAP_THRESHOLD = 100;
export const SLIDE_GAP = 12;
